import { Sprites } from "../../../utils/Sprites"
import { MakeVideoImages } from "../MakeVideoAssets"
import { MakeVideoSprite } from "../MakeVideoTypes"

export class MakeAVideoTitleSprite implements MakeVideoSprite {
    active: boolean
    private sprite: Phaser.Sprite

    constructor(game: Phaser.Game, group: Phaser.Group, x: number, y: number, debug: boolean) {
        this.sprite = Sprites.add(game, MakeVideoImages.TITLE, {debug, group, x, y})
        this.visible = false
        this.active = true
    }

    destroy = () => {
        this.sprite.destroy(true)
        this.active = false
    }

    set visible(visible: boolean) {
        this.sprite.visible = visible
    }
}